import { Component, Input, ChangeDetectorRef } from '@angular/core';
import { Controllers } from '@shared/core/controllers';
import { TilesComponent } from '../../tiles.shared.component';
@Component({
    selector: 'shared-tile-for-loyalty-points',
    templateUrl: './tile-for-loyalty-points.shared.component.html',
    styleUrls: ['./tile-for-loyalty-points.shared.component.scss']
})
export class TileForLoyaltyPointsComponent extends TilesComponent {
    @Input() public loyaltyPoints: OLO.Ordering.ILoyaltyPointsModel;
    constructor(
        public changeDetectorRef: ChangeDetectorRef,
        public controllers: Controllers,
    ) {
        super(changeDetectorRef, controllers);
    }
}
